import { empty, filter } from '@esentai/core/query-dsl';

export { defaultDateRange } from '@/features/purchasesStatistics/consts/filters';

export const defaultCustomerId = filter(empty());
